(() => {
  const root = document.querySelector('[data-motorcars]');
  if (!root) return;

  const cards = [...root.querySelectorAll('[data-motorcar-card]')];
  const filters = [...root.querySelectorAll('[data-brand-filter]')];

  const setFilter = (brand) => {
    cards.forEach((card) => {
      card.hidden = brand !== 'all' && card.dataset.brand !== brand;
    });
    filters.forEach((button) => {
      const active = button.dataset.brandFilter === brand;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };

  filters.forEach((button) => {
    button.addEventListener('click', () => setFilter(button.dataset.brandFilter));
  });

  root.querySelectorAll('[data-motorcar-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = track ? [...track.children] : [];
    const current = gallery.querySelector('[data-gallery-current]');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-go]')];
    if (!track || slides.length < 2) return;

    let index = 0;
    const update = (next) => {
      index = (next + slides.length) % slides.length;
      gallery.dataset.galleryIndex = String(index);
      track.style.setProperty('--gallery-index', String(index));
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        if (thumbnailIndex === index) {
          thumbnail.setAttribute('aria-current', 'true');
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
    };

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => update(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => update(index + 1));
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => update(Number(thumbnail.dataset.galleryGo)));
    });

    let touchStart = 0;
    gallery.addEventListener('touchstart', (event) => {
      touchStart = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const delta = (event.changedTouches[0]?.clientX || 0) - touchStart;
      if (Math.abs(delta) > 42) update(index + (delta < 0 ? 1 : -1));
    }, { passive: true });
  });

  root.querySelectorAll('[data-motorcar-inquiry]').forEach((link) => {
    link.addEventListener('click', () => {
      const vehicle = link.dataset.motorcarInquiry;
      const form = document.querySelector('#private-inquiry form');
      if (!form || !vehicle) return;

      let vehicleField = form.querySelector('input[name="contact[Vehicle]"]');
      if (!vehicleField) {
        vehicleField = document.createElement('input');
        vehicleField.type = 'hidden';
        vehicleField.name = 'contact[Vehicle]';
        form.append(vehicleField);
      }
      vehicleField.value = vehicle;

      const interest = form.querySelector('select[name="contact[Interest]"]');
      if (interest) {
        const matchingOption = [...interest.options].find((option) => /hypercar|sammler|collector/i.test(option.textContent));
        if (matchingOption) interest.value = matchingOption.value;
      }

      const message = form.querySelector('textarea[name="contact[body]"]');
      const sentence = `Ich interessiere mich für den ${vehicle} und bitte um eine vertrauliche Prüfung von Verfügbarkeit, Historie, Spezifikation und Konditionen.`;
      if (message && !message.value.includes(vehicle)) {
        message.value = message.value.trim() ? `${message.value.trim()}\n\n${sentence}` : sentence;
      }
    });
  });

  const revealHashTarget = () => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id.startsWith('motorcar-')) return;
    const target = document.getElementById(id);
    if (!target?.matches('[data-motorcar-card]')) return;
    setFilter(target.dataset.brand || 'all');
    requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  };

  window.addEventListener('hashchange', revealHashTarget);
  if (window.location.hash) revealHashTarget();
})();
